import React, { useEffect, Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withDashboard from "../../HOC/withDashboard";
import Pagination from "../../components/NewPagination";
import {
  fetchVirtualCards,
  updateUnfreezeVirtualCard,
  updateFreezeVirtualCard,
} from "../../services/VirtualCardServices";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  IconButton,
  Switch,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import "./index.css";
import Loader from "../../components/Loader";

const VirtualCardList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // State for paginated data
  // Pagination states for cards
  const [totalCardData, setTotalCardData] = useState(0);
  const [cardData, setCardData] = React.useState([]);
  const [cardDataFilter, setCardDataFilter] = useState({
    search: "",
    page: 0,
    limit: 10,
  });
  const statusLabels = {
    freeze: "Freeze",
    deleted: "Deleted",
    active: "Active",
    blocked: "Blocked",
    suspended: "Suspended",
  };

  useEffect(() => {
    getCardData();
  }, [cardDataFilter]);

  const onChangeCardDataFilter = (name, value) => {
    setCardDataFilter({ ...cardDataFilter, [name]: value });
  };

  const getCardData = () => {
    setIsLoading(true);
    dispatch(fetchVirtualCards(cardDataFilter))
      .then((res) => {
        setTotalCardData(res?.data?.data?.total);
        setCardData(res?.data?.data?.data);
        setIsLoading(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching virtual card users:", message);
        setIsLoading(false);
      });
  };

  const freezeVirtualCard = async (cardId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Freeze this card.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Freeze it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        dispatch(updateFreezeVirtualCard({ card_id: cardId }))
          .then((res) => {
            setIsLoading(false);
            getCardData();
            Swal.fire("Success", "Virtual card freeze successfully", "success");
          })
          .catch(({ message, errorData, statusCode }) => {
            Swal.fire("Error", "Failed to freeze Virtual card", "error");
            setIsLoading(false);
          });
      }
    });
  };

  const unFreezeVirtualCard = async (cardId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Unfreeze this card.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Unfreeze it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        dispatch(updateUnfreezeVirtualCard({ card_id: cardId }))
          .then((res) => {
            setIsLoading(false);
            getCardData();
            Swal.fire(
              "Success",
              "Virtual card Unfreeze successfully",
              "success"
            );
          })
          .catch(({ message, errorData, statusCode }) => {
            Swal.fire("Error", "Failed to Unfreeze Virtual card", "error");
            setIsLoading(false);
          });
      }
    });
  };

  return (
    <Fragment>
      <div className="gift-cards-container">
        <div className="gift-cards-button-container"></div>

        {/* Gift Card Categories Section */}
        <Card className="gift-cards-category-card">
          <div className="table-title mb-2">
            <span>Virtual Cards</span>
          </div>
          <div className="gift-cards-table-container mb-5">
            {isLoading ? (
              <div className="flex justify-center items-center p-4">
                <CircularProgress />
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Phone No</th>
                    <th>Card Id</th>
                    <th>Card Name</th>
                    <th>Card Number</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {cardData &&
                    cardData.length > 0 &&
                    cardData.map((useCard) => (
                      <tr key={useCard._id}>
                        <td>{useCard?.cardholderId?.email}</td>
                        <td>{useCard?.cardholderId?.phone}</td>
                        <td>{useCard?.cardId}</td>
                        <td>{useCard?.cardName}</td>
                        <td>{useCard?.cardNumber}</td>
                        <td>
                          {statusLabels[useCard?.status] || "Unknown Status"}
                        </td>
                        <td>
                          {useCard?.status && useCard?.status == "freeze" ? (
                            <IconButton
                              onClick={() => unFreezeVirtualCard(useCard._id)}
                            >
                              <EditIcon />
                            </IconButton>
                          ) : (
                            <IconButton
                              onClick={() => freezeVirtualCard(useCard._id)}
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="gift-cards-pagination-container">
            <Pagination
              items={totalCardData}
              initialPage={cardDataFilter?.page}
              onChangePage={onChangeCardDataFilter}
              per_page={cardDataFilter?.limit}
            />
          </div>
        </Card>
      </div>
      <Loader />
    </Fragment>
  );
};

export default withDashboard(VirtualCardList);
